import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { User } from "../../types";
import { BottomBar, BottomInner, Container, Cta, Headline, Page, Sub, TopBar } from "./ReservationPage";
import { RESERVATION_EVENTS, trackReservation } from "./tracking";

// web41 coming-soon screen (/reserve/soon): honest fake-door landing. Primary
// CTA starts the 14-day trial today (annual checkout); this recovery path has
// its own event.
const Tools = styled.div`
  margin: 40px 0 20px;
  text-align: center;
  font-size: 64px;
  line-height: 1;
`;

const Body = styled(Sub)`
  color: #4b5567;
`;

const BackLink = styled.button`
  margin-top: 14px;
  background: none;
  border: 0;
  padding: 0;
  font-family: Lato, sans-serif;
  font-size: 17px;
  color: #4b5567;
  cursor: pointer;
`;

export function ReservationComingSoon({ user }: { user: User }) {
  const navigate = useNavigate();
  const viewedRef = useRef(false);

  useEffect(() => {
    if (!user || !user.focus) {
      navigate("/");
      return;
    }
    if (viewedRef.current) return;
    viewedRef.current = true;
    trackReservation(RESERVATION_EVENTS.comingSoonViewed);
  }, [user, navigate]);

  const startTrial = () => {
    trackReservation(RESERVATION_EVENTS.trialFromComingSoon);
    navigate("/checkout?plan=committed");
  };

  const backToPricing = () => {
    navigate("/results");
    window.setTimeout(() => {
      document.getElementById("pricingbox")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
  };

  return (
    <Page>
      <TopBar>Reservations</TopBar>
      <Container>
        <Tools aria-hidden="true">🛠️</Tools>
        <Headline>
          Reservations are <span>coming soon</span>.
        </Headline>
        <Body>
          We&apos;re building this right now, and you&apos;re clearly the kind of person it&apos;s for. Thanks for showing
          us it matters.
        </Body>
        <Body>
          <strong>For today:</strong> your 14-day free trial is ready whenever you are, and there&apos;s no charge
          before it ends.
        </Body>
      </Container>

      <BottomBar>
        <BottomInner>
          <Cta type="button" onClick={startTrial} data-reservation-cta="start-trial">
            Start free trial
          </Cta>
          <BackLink type="button" onClick={backToPricing}>
            Back to pricing
          </BackLink>
        </BottomInner>
      </BottomBar>
    </Page>
  );
}
